import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

export { Checkbox, CheckboxProps };
